import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroll-arrow"
export default class extends Controller {
  static targets = ["document", "desktopArrow"]

  connect() {
    this.documentTarget.addEventListener("scroll", () => {
      this.desktopArrowTarget.classList.add("opacity-0");
    });
  }
}
